import { Share2 } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminSyndication() {
  return (
    <CollectionAdmin
      path="syndication"
      title="Syndication API"
      subtitle="Partneri koji automatski preuzimaju naše članke"
      icon={Share2}
      testid="admin-syndication"
      fields={[
        { key: 'name', label: 'Ime partnera' },
        { key: 'api_key', label: 'API ključ' },
        { key: 'webhook_url', label: 'Webhook URL' },
        { key: 'categories', label: 'Kategorije (zarezom odvojene)' },
        { key: 'active', label: 'Aktivan', type: 'checkbox' },
      ]}
    />
  );
}
